export default __webpack_public_path__ + "b1448a7603e6ef91cf483027b621ba69.jpg";